export * from './transaction-detail-open-finance'
